module.exports = __webpack_public_path__ + "img/ecloud.e067001c.svg";